import { ModalsWrapperContext } from '@kanda-libs/ks-design-library';
import { useCallback, useContext } from 'react';

export interface OpenBankingMobileHook {
  onClick: () => void;
  onClose: () => void;
}

export default function useOpenBankingMobile(): OpenBankingMobileHook {
  const { showModal, hideModal } = useContext(ModalsWrapperContext);

  const onClick = useCallback(() => {
    showModal('open-banking-info');
  }, [showModal]);

  const onClose = useCallback(() => {
    hideModal('open-banking-info');
  }, [hideModal]);

  return {
    onClick,
    onClose,
  };
}
